import { Box, Icon } from '@branch-messenger/willow-ui'
import styled, { css } from 'styled-components'

import { largeTabletAndDown } from '@/styles/media'

export const TaxAlertContainer = styled(Box).attrs({
  $px: 8,
})`
  margin: 0 -${({ theme }) => theme.space[8]};
  background-color: ${({ theme }) => theme.colors.surface};
  ${largeTabletAndDown(css`
    border: none;
    padding: 0;
    margin: ${({ theme }) => theme.space[6]} 0;
  `)}
`

export const TaxAlertContent = styled(Box).attrs({
  $display: 'flex',
  $justify: 'space-between',
  $align: 'center',
  $flexWrap: true,
})`
  gap: ${({ theme }) => theme.space[4]};
`

export const TaxUpdateErrorIcon = styled(Icon).attrs({
  color: 'warning',
})`
  height: 128px;
  width: 128px;
  align-self: center;
`
export const TermsList = styled.ul`
  padding-left: ${({ theme }) => theme.space[4]};
`
export const TermsListItem = styled.li`
  font-size: ${({ theme }) => theme.fontSizes.xs};
`
